(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["khaal-collection-showcase"] && !Shopify.designMode) return;
  try {
    
  // Right-button drag on the native Fabric carousel. Touch and trackpad remain native.
  let drag = null;
  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 2) return;
    const root = event.target.closest('.kc-showcase');
    if (!root) return;
    // The first slideshow-slides is the outer product row, not a card's image gallery.
    const scroller = root.querySelector('.resource-list__carousel slideshow-slides');
    if (!scroller || !scroller.contains(event.target)) return;
    event.preventDefault();
    drag = {
      scroller,
      x: event.clientX,
      left: scroller.scrollLeft,
      snap: scroller.style.scrollSnapType,
      root: scroller.closest('.kc-showcase')
    };
    scroller.style.scrollSnapType = 'none';
    drag.root.classList.add('is-right-dragging');
    try { scroller.setPointerCapture(event.pointerId); } catch (error) { /* Optional */ }
  });

  document.addEventListener('pointermove', (event) => {
    if (!drag) return;
    if (!(event.buttons & 2)) return endDrag();
    event.preventDefault();
    drag.scroller.scrollLeft = drag.left - (event.clientX - drag.x);
  });

  function endDrag() {
    if (!drag) return;
    drag.scroller.style.scrollSnapType = drag.snap;
    drag.root.classList.remove('is-right-dragging');
    drag = null;
  }
  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);
  window.addEventListener('blur', endDrag);
  document.addEventListener('contextmenu', (event) => {
    if (event.target.closest('.kc-showcase slideshow-slides')) event.preventDefault();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
